<div class="operator-add-vehicle-body">
  <div class="operator-add-vehicle-body__block">
    <div class="operator-add-vehicle-header">
      <div class="operator-add-vehicle-header__back-btn">
        <xp-back-button class="operator-add-vehicle-back"
                        iconSrc="/XpressApp/assets/images/arrow-left-icon.svg"
                        (click)="backToOperatorVehicles()">Back</xp-back-button>
      </div>
    </div>

    <div class="step-progress">
      <div class="step"
           [ngClass]="(vehicleStepProgressActive === vehicleStepProgressEnum.VehicleDetails) ? 'step-active' : (addOperatorVehicleModel.IsVehicleDetailsFieldsFilled()) ? 'completed' : ''"
           (click)="changeStepProgress(vehicleStepProgressEnum.VehicleDetails, addOperatorVehicleModel.IsVehicleDetailsFieldsFilled())">
        <div class="circle"><img src="/XpressApp/assets/images/check-icon.svg" /></div>
        <p>Vehicle Details</p>
      </div>
      <div class="step"
           [ngClass]="(vehicleStepProgressActive === vehicleStepProgressEnum.VehiclePhotos) ? 'step-active' : (addOperatorVehicleModel.IsVehiclePhotoFieldsFilled()) ? 'completed' : ''"
           (click)="changeStepProgress(vehicleStepProgressEnum.VehiclePhotos, addOperatorVehicleModel.IsVehiclePhotoFieldsFilled())">
        <div class="circle"><img src="/XpressApp/assets/images/check-icon.svg" /></div>
        <p>Vehicle Photos</p>
      </div>
      <div class="step"
           [ngClass]="(vehicleStepProgressActive === vehicleStepProgressEnum.VehicleOwnership) ? 'step-active' : (addOperatorVehicleModel.IsVehicleOwnershipFieldsFilled()) ? 'completed' : ''"
           (click)="changeStepProgress(vehicleStepProgressEnum.VehicleOwnership, addOperatorVehicleModel.IsVehicleOwnershipFieldsFilled())">
        <div class="circle"><img src="/XpressApp/assets/images/check-icon.svg" /></div>
        <p>Vehicle Ownership</p>
      </div>
      <div class="step"
           [ngClass]="(vehicleStepProgressActive === vehicleStepProgressEnum.TnvcDocuments) ? 'step-active' : (addOperatorVehicleModel.IsTnvcFieldsFilled()) ? 'completed' : ''"
           (click)="changeStepProgress(vehicleStepProgressEnum.TnvcDocuments, addOperatorVehicleModel.IsTnvcFieldsFilled())">
        <div class="circle"><img src="/XpressApp/assets/images/check-icon.svg" /></div>
        <p>TNVS Documents</p>
      </div>
      <div class="step"
           [ngClass]="(vehicleStepProgressActive === vehicleStepProgressEnum.BoundaryFee) ? 'step-active' : (addOperatorVehicleModel.IsBoundaryFieldsFilled()) ? 'completed' : ''"
           (click)="changeStepProgress(vehicleStepProgressEnum.BoundaryFee, addOperatorVehicleModel.IsBoundaryFieldsFilled())">
        <div class="circle"><img src="/XpressApp/assets/images/check-icon.svg" /></div>
        <p>Boundary Fee</p>
      </div>
    </div>

    <div class="app-scrollWrapper">

      <!-- Step 1: Vehicle Details -->
      <div *ngIf="vehicleStepProgressActive === vehicleStepProgressEnum.VehicleDetails" class="app-scrollContainer">
        <div class="operator-add-vehicle-title mb-4">
          Vehicle Details
        </div>

        <div class="col-12 p-0">
          <div class="col-6 p-0 pr-2">
            <div class="operator-add-vehicle-label">Vehicle Type</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <mat-select placeholder="Select Vehicle Type"
                          [(ngModel)]="addOperatorVehicleModel.VehicleTypeId"
                          (ngModelChange)="onChangeVehicleTypeEvent($event)">
                <mat-option *ngFor="let item of operatorVehicleTypeList" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.VehicleTypeId}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>
        </div>

        <hr class="operator-add-vehicle-hr" />

        <div class="col-12 p-0 flex-row flex-wrap">
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">Vehicle Make</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <mat-select placeholder="Select Vehicle Make"
                          [(ngModel)]="addOperatorVehicleModel.VehicleBrandId"
                          (ngModelChange)="onChangeVehicleMakeEvent($event)">
                <mat-option *ngFor="let item of vehicleBrands" [value]="item.Id">{{item.NameBrand}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.VehicleBrandId}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">Vehicle Model</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <mat-select placeholder="Select Vehicle Model"
                          [(ngModel)]="addOperatorVehicleModel.VehicleModelId"
                          (ngModelChange)="onChangeVehicleModelEvent($event)"
                          [disabled]="!addOperatorVehicleModel.VehicleBrandId || !addOperatorVehicleModel.VehicleTypeId">
                <mat-option *ngFor="let item of vehicleModels" [value]="item.Id">{{item.NameModel}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.VehicleModelId}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>

          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">Build Year</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <input matInput [matDatepicker]="yearPicker" readonly
                     placeholder="Enter Build Year"
                     [ngModel]="addOperatorVehicleModel.VehicleYearStr"
                     (ngModelChange)="addOperatorVehicleModel.VehicleYearStr = $event; setBuildYear()">
              <mat-datepicker-toggle matSuffix [for]="yearPicker"></mat-datepicker-toggle>
              <mat-datepicker #yearPicker startView="multi-year"
                              (yearSelected)="chooseYear($event, yearPicker)"></mat-datepicker>
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.VehicleYearStr}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">Vehicle Color</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <mat-select placeholder="Select Vehicle Color"
                          [(ngModel)]="addOperatorVehicleModel.VehicleColor">
                <mat-option *ngFor="let item of colorTypeList" [value]="item.value">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.VehicleColor}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>

          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">Plate Number</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <input matInput type="text" placeholder="Enter Plate Number"
                     [(ngModel)]="addOperatorVehicleModel.NumberPlate"
                     [readonly]="isNumberPlateLocked">
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.NumberPlate}" class="error-none">
              <p>This field is required</p>
            </div>
            <xp-message *ngIf="isNumberPlateLocked"
                        class="operator-add-vehicle-hint"
                        [plain]="true">Plate is locked after uploads. Delete uploaded photos/documents to change it.</xp-message>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">Registration Number (optional)</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <input matInput type="text" placeholder="Enter Registration Number"
                     [(ngModel)]="addOperatorVehicleModel.RegistrationNumber">
            </mat-form-field>
          </div>
        </div>

        <hr class="operator-add-vehicle-hr" />

        <div class="col-12 p-0 flex-row flex-wrap">
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">Do you own this vehicle?</div>
            <mat-radio-group [(ngModel)]="addOperatorVehicleModel.IsOwner" class="flex flex-wrap gap-3 mt-3">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false" class="ml-3">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="col-12 p-0 flex-row flex-wrap" *ngIf="!addOperatorVehicleModel.IsOwner">
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">Owner First Name</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <input matInput placeholder="Enter Owner First Name"
                     [(ngModel)]="addOperatorVehicleModel.OwnerFirstName">
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.OwnerFirstName}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">Owner Last Name</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <input matInput placeholder="Enter Owner Last Name"
                     [(ngModel)]="addOperatorVehicleModel.OwnerLastName">
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.OwnerLastName}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">Owner Email</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <input matInput placeholder="Enter Owner Email"
                     [(ngModel)]="addOperatorVehicleModel.OwnerEmail">
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.OwnerEmail}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">Owner Phone</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <input matInput placeholder="Enter Owner Phone"
                     [(ngModel)]="addOperatorVehicleModel.OwnerPhone">
            </mat-form-field>
            <div [ngClass]="{'error-message': showValidationError && !addOperatorVehicleModel.OwnerPhone}" class="error-none">
              <p>This field is required</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2: Vehicle Photos -->
      <div class="step-content" *ngIf="vehicleStepProgressActive === vehicleStepProgressEnum.VehiclePhotos">
        <div class="operator-add-vehicle-title mb-4">Vehicle Photos</div>
        <div class="operator-add-vehicle-sub-title mb-4">Accepted Files: .jpg, .jpeg, .png, .pdf (max 5MB)</div>
        <div class="col-12 p-0 flex-row flex-wrap">
          <ng-container *ngFor="let slot of vehiclePhotoUploadSlots">
            <div class="col-6 p-0 mb-3 pr-2">
              <div class="operator-add-vehicle-label">{{slot.label}}</div>
              <div class="mt-3">
                <xp-drop-zone class="operator-add-vehicle-upload-field operator-add-vehicle-upload-field--with-hint"
                              *ngIf="isUploadFieldLoading(slot.field) || !hasUploadFieldUrl(slot.field)"
                              hint="Drop files here to upload…"
                              dragText="Drop files here to upload…"
                              browseLabel="Browse File"
                              [showProgress]="isUploadFieldLoading(slot.field)"
                              (filesSelected)="fileBrowseHandler($event, slot.field)"></xp-drop-zone>
                <xp-file-row *ngIf="!isUploadFieldLoading(slot.field) && hasUploadFieldUrl(slot.field)"
                             [thumbSrc]="getUploadFieldUrl(slot.field)"
                             iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                             [name]="slot.label"
                             removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                             (remove)="deleteUpload(slot.field)"></xp-file-row>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Step 3: Vehicle Ownership -->
      <div class="step-content" *ngIf="vehicleStepProgressActive === vehicleStepProgressEnum.VehicleOwnership">
        <div class="operator-add-vehicle-title mb-4">Vehicle Ownership</div>
        <div class="col-12 p-0 flex-row flex-wrap">
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">LTO Official Receipt (OR)</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('LTOOfficialReceiptImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'LTO Official Receipt (OR)'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('LTOOfficialReceiptImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('LTOOfficialReceiptImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="addOperatorVehicleModel.LTOOfficialReceiptImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'LTOOfficialReceiptImageUrl')"></xp-drop-zone>
            </div>
            <div class="operator-add-vehicle-label mt-3">Expiration Date</div>
            <mat-form-field appearance="outline" class="w-full mt-2">
              <input matInput [matDatepicker]="ltoExpPicker"
                     [(ngModel)]="addOperatorVehicleModel.LTOOfficialReceiptExpireAt"
                     [min]="minDate"
                     placeholder="Select Expiration Date">
              <mat-datepicker-toggle matSuffix [for]="ltoExpPicker"></mat-datepicker-toggle>
              <mat-datepicker #ltoExpPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">Certificate of Registration (CR)</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('CertificateRegistrationImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'Certificate of Registration (CR)'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('CertificateRegistrationImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('CertificateRegistrationImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="addOperatorVehicleModel.CertificateRegistrationImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'CertificateRegistrationImageUrl')"></xp-drop-zone>
            </div>
          </div>
          <div class="col-6 p-0 mb-3 pr-2" *ngIf="!addOperatorVehicleModel.IsOwner">
            <div class="operator-add-vehicle-label">SPA</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('SPAImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'SPA'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('SPAImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('SPAImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="addOperatorVehicleModel.SPAImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'SPAImageUrl')"></xp-drop-zone>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 4: TNVS Documents -->
      <div class="step-content" *ngIf="vehicleStepProgressActive === vehicleStepProgressEnum.TnvcDocuments">
        <div class="operator-add-vehicle-title mb-4">
          TNVS Documents
        </div>

        <div class="col-12 p-0 flex-row flex-wrap">
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">Is the vehicle registered with XPRESS TNC?</div>
            <mat-radio-group [(ngModel)]="addOperatorVehicleModel.IsRegisteredTNC" class="flex flex-wrap gap-3 mt-3">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false" class="ml-3">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div *ngIf="!addOperatorVehicleModel.IsRegisteredTNC" class="col-12 p-0 flex-row flex-wrap">
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">Select Existing Transport Network Companies (TNC)</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <mat-select placeholder="Select TNC"
                          [(ngModel)]="addOperatorVehicleModel.TNCType">
                <mat-option *ngFor="let item of ridesharingAppModelList" [value]="item.value">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">PA/CPC Case Number</div>
            <mat-form-field appearance="outline" class="w-full mt-3">
              <input matInput type="text" placeholder="Enter PA/CPC Case Number"
                     [(ngModel)]="addOperatorVehicleModel.PaOrCpcCaseNumber">
            </mat-form-field>
          </div>
          <div class="col-6 p-0 mb-3 pr-2">
            <div class="operator-add-vehicle-label">PA Document</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('ProvisionalAuthorityImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'PA Document'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('ProvisionalAuthorityImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('ProvisionalAuthorityImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="addOperatorVehicleModel.ProvisionalAuthorityImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'ProvisionalAuthorityImageUrl')"></xp-drop-zone>
            </div>
            <div class="operator-add-vehicle-label mt-3">PA Expiration Date</div>
            <mat-form-field appearance="outline" class="w-full mt-2">
              <input matInput [matDatepicker]="paExpPicker"
                     [(ngModel)]="addOperatorVehicleModel.ProvisionalAuthorityExpireAt"
                     [min]="minDate"
                     placeholder="Select Expiration Date">
              <mat-datepicker-toggle matSuffix [for]="paExpPicker"></mat-datepicker-toggle>
              <mat-datepicker #paExpPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6 p-0 mb-3 pl-2">
            <div class="operator-add-vehicle-label">CPC Document</div>
            <div class="mt-3">
              <xp-file-row class="mb-2"
                           *ngFor="let file of getUploadedFiles('CertificatePublicConvenienceImageUrl')"
                           [thumbSrc]="file.url"
                           [isPdf]="file.isPdf"
                           pdfIconSrc="XpressApp/assets/images/pdf-icon.png"
                           iconSrc="Content/xpress-app/images/operator/signup/file-jpg.svg"
                           [name]="file.fileName || 'CPC Document'"
                           removeIconSrc="Content/xpress-app/images/operator/signup/remove-upload.svg"
                           (remove)="deleteUpload('CertificatePublicConvenienceImageUrl', file.id)"></xp-file-row>
              <xp-drop-zone class="operator-add-vehicle-upload-field"
                            *ngIf="canUploadMoreFiles('CertificatePublicConvenienceImageUrl')"
                            browseLabel="Browse File"
                            [accept]="acceptedVehicleDocTypes"
                            [multiple]="true"
                            [showProgress]="addOperatorVehicleModel.CertificatePublicConvenienceImageUrlIsLoading"
                            (filesSelected)="fileBrowseHandler($event, 'CertificatePublicConvenienceImageUrl')"></xp-drop-zone>
            </div>
            <div class="operator-add-vehicle-label mt-3">CPC Expiration Date</div>
            <mat-form-field appearance="outline" class="w-full mt-2">
              <input matInput [matDatepicker]="cpcExpPicker"
                     [(ngModel)]="addOperatorVehicleModel.CertificatePublicConvenienceExpireAt"
                     [min]="minDate"
                     placeholder="Select Expiration Date">
              <mat-datepicker-toggle matSuffix [for]="cpcExpPicker"></mat-datepicker-toggle>
              <mat-datepicker #cpcExpPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Step 5: Boundary Fee -->
      <div class="step-content boundary-step" *ngIf="vehicleStepProgressActive === vehicleStepProgressEnum.BoundaryFee">
        <div class="operator-add-vehicle-title mb-4">
          Boundary Fee
        </div>

        <div class="amount-row mb-3">
          <xp-field class="amount-col"
                    label="Boundary Amount"
                    infoIconSrc="/XpressApp/assets/images/info-black.png"
                    infoTooltip="Amount paid by the driver"
                    errorText="This field is required"
                    [showError]="showValidationError && !addOperatorVehicleModel.BoundaryFeeAmount">
            <xp-input type="number"
                      [min]="0"
                      [max]="1000000"
                      suffixText=".00"
                      placeholder="Enter Amount"
                      [value]="addOperatorVehicleModel.BoundaryFeeAmount"
                      (valueChange)="addOperatorVehicleModel.BoundaryFeeAmount = $any($event)"></xp-input>
          </xp-field>

          <xp-field class="amount-col"
                    label="Processing fee"
                    infoIconSrc="/XpressApp/assets/images/info-black.png"
                    infoTooltip="Payment processing fee collected by Xpress">
            <xp-input class="readonly-input"
                      type="number"
                      [min]="0"
                      [readonly]="true"
                      prefixText="₱"
                      placeholder="Enter Amount"
                      [value]="addOperatorVehicleModel.BoundaryProcessingFee"
                      (valueChange)="addOperatorVehicleModel.BoundaryProcessingFee = $any($event)"></xp-input>
          </xp-field>

          <div class="earn-note">
            You will receive ₱{{addOperatorVehicleModel.GetBoundaryEarning()}}
          </div>
        </div>

        <xp-field class="days-field mb-3"
                  label="Days Applied"
                  errorText="At least one day must be selected."
                  [showError]="addOperatorVehicleModel.BoundaryAvailableDays.length === 0">
          <xp-toggle-buttons class="mt-3"
                             [options]="dayOptions"
                             [selected]="addOperatorVehicleModel.BoundaryAvailableDays"
                             (toggled)="toggleDay($event)"></xp-toggle-buttons>
        </xp-field>

        <xp-field label="Boundary Duration"
                  infoIconSrc="/XpressApp/assets/images/info-black.png"
                  infoTooltip="Period of time the fee lasts for."
                  errorText="End Time should be greater than Start Time"
                  [showError]="timeStart > timeEnd">
          <div class="boundary-duration-row">
            <div class="duration-times">
              <div class="time-col">
                <label class="time-label">Start Time</label>
                <xp-input type="time"
                          [value]="timeStartStr"
                          (valueChange)="timeStartStr = $any($event)"></xp-input>
              </div>
              <div class="error-message-bounder"
                   *ngIf="showValidationError && !addOperatorVehicleModel.BoundaryAvailableFromHours">
                This field is required
              </div>
              <div class="time-col mt-2">
                <label class="time-label">End Time</label>
                <xp-input type="time"
                          [value]="timeEndStr"
                          (valueChange)="timeEndStr = $any($event)"></xp-input>
              </div>
            </div>
            <mat-radio-group [(ngModel)]="addOperatorVehicleModel.CollectAtStart" class="boundary-collect-options">
              <mat-radio-button [value]="true">Collect at Start</mat-radio-button>
              <mat-radio-button [value]="false" [disabled]="true">Collect at End (Coming Soon)</mat-radio-button>
            </mat-radio-group>
          </div>
        </xp-field>
      </div>

    </div>

    <div class="operator-add-vehicle-footer">
      <button mat-stroked-button class="red-color mr-2" (click)="backToOperatorVehicles()">Discard Changes</button>
      <button mat-flat-button color="primary"
              *ngIf="vehicleStepProgressActive !== vehicleStepProgressEnum.BoundaryFee"
              [disabled]="!checkFieldsByStepProgress()"
              (click)="clickNext()">Next</button>
      <button mat-flat-button color="primary"
              *ngIf="vehicleStepProgressActive === vehicleStepProgressEnum.BoundaryFee"
              [disabled]="!checkFieldsByStepProgress() || ((!timeStart || !timeEnd) || timeStart > timeEnd)"
              (click)="clickNext()">Add Vehicle</button>
    </div>
  </div>
</div>
